export default __webpack_public_path__ + "static/media/selectScreenH1.c193fd1a.png";